import React from "react";

import { NavLink } from "react-router-dom";
import roles from "../../constants/roles";
import { useAuth } from "../../providers/auth";

const DashboardNav = props => {
  const { user } = useAuth();
  const userRole = user.group_id;

  const management = [
    roles.GERENCIA,
    roles.DIRETORIA
  ];

  const prospecting = [
    roles.PROSPECTING
  ];

  const comercial = [
    roles.COMERCIAL
  ];

  // logins dos logs atuais na verdade é "Clientes que logaram no site entre os períodos de"
  // grafico gerado no inicio

  return (
    <ul className="dashboard__nav">
      {userRole <= 2 &&
        <>
          <li className="dashboard__nav-item">
            <NavLink className="dashboard__nav-link" to="/">
              Logs por admin
            </NavLink>
          </li>

          <li className="dashboard__nav-item">
            <NavLink className="dashboard__nav-link" to="/sent-messages">
              Mensagens enviadas por admin
            </NavLink>
          </li>

          <li className="dashboard__nav-item">
            <NavLink className="dashboard__nav-link" to="/received-messages">
              Mensagens recebidas por admin
            </NavLink>
          </li>
          <li className="dashboard__nav-item">
            <NavLink className="dashboard__nav-link" to="/month-approvals">
              Aprovações no mês atual
            </NavLink>
          </li>
          <li className="dashboard__nav-item">
            <NavLink className="dashboard__nav-link" to="/calls">
              Ligações p/ dia
            </NavLink>
          </li>
          <li className="dashboard__nav-item">
            <NavLink className="dashboard__nav-link" to="/outdated-table">
              Relação diária dos Desatualizados
            </NavLink>
          </li>
        </>
      }

      {userRole == 3 &&
        <>
          <li className="dashboard__nav-item">
            <NavLink className="dashboard__nav-link" to="/number-of-logs-from-the-current-admin">
              Logs atuais
            </NavLink>
          </li>

          <li className="dashboard__nav-item">
            <NavLink className="dashboard__nav-link" to="/customer-logins-from-the-current-admin">
              Logins dos logs atuais
            </NavLink>
          </li>
        </>
      }

      {userRole == 8 &&
        <>
          <li className="dashboard__nav-item">
            <NavLink className="dashboard__nav-link" to="/number-of-logs-from-the-current-admin">
              Logs atuais
            </NavLink>
          </li>
        </>
      }

      {userRole == 11 &&
        <>
          <li className="dashboard__nav-item">
            <NavLink className="dashboard__nav-link" to="/number-of-logs-from-the-current-admin">
              Logs atuais
            </NavLink>
          </li>

          <li className="dashboard__nav-item">
            <NavLink className="dashboard__nav-link" to="/customer-logins-from-the-current-admin">
              Logins dos logs atuais
            </NavLink>
          </li>
        </>
      }
    </ul>
  );
}

export default DashboardNav;